<!-- ================管理端-读书会详情====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container"> 读书会详情 </div>
        </div>
        <div class="create-content-container">
            <div class="event-base-info-container">
                <div class="event-part1-l">
                    <div class="event-info-item-auto">
                        <span class="item-span">活动主题：</span>
                        {{eventForm.eventTheme}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">所属主题：</span>
                        {{eventForm.eventItemName}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">学段年级：</span>
                        {{eventForm.periodName}}•{{eventForm.eventGradeName}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">活动时长：</span>
                        {{eventForm.eventTime}}
                    </div>
                    <div class="event-info-item-auto" v-if="eventBookList&&eventBookList.length>0">
                        <span class="item-span">核心读物</span>：
                    </div>
                    <div class="event-book-container" v-if="eventBookList&&eventBookList.length>0">
                        <div class="book-list-one" v-for="(item,index) in eventBookList" :key="index">
                            <div class="book-cover">
                                <img alt="" :src="item.bookCover" class="img-100">
                            </div>
                            <div class="book-t">
                                {{item.bookName}}
                            </div>
                        </div>
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">活动准备：</span>
                    </div>
                    <div class="event-info-item-auto" style="white-space: pre-wrap;margin-left: 10px">
                        {{eventForm.eventPrepare}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">活动流程</span>：
                    </div>
                    <div class="event-info-item-auto" style="white-space: pre-wrap;margin-left: 10px">
                        {{eventForm.eventFlow}}
                    </div>
                </div>
                <div class="event-part1-r">
                    <div class="event-info-item-auto">
                        <span class="item-span">活动封面：</span>
                    </div>
                    <div class="event-base-info-cover">
                        <img class="img-100"  :src="eventForm.eventCover" alt="">
                    </div>
                </div>
            </div>

        </div>
    </div>


</template>
<script>
import {serviceUrl} from "@/utils/global";
import {infoEvent} from "@/api/admin/event"

export default {
    components: {},
    name: "eventDetail",
    data() {
        return {
            token: this.$storage.get("token"),
            serviceUrl,
            // 遮罩层
            loading: true,
            eventId:'',
            fileList:[],
            // 表单参数
            eventForm:{},  //数据
            eventBookList:[],
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.eventId) {
            this.eventId = this.$route.query.eventId
            this.queryEventInfo()
        }
    },
    mounted() {

    },
    methods: {
        backList(){
            this.$router.push({
                path: "/event",
            });
        },
        queryEventInfo(){
            infoEvent({ eventId: this.eventId }).then(res => {
                if (res.data.code === 1) {
                    this.eventForm = res.data.data;
                    // 读物
                    this.eventBookList = this.eventForm.bookList;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
    },
}
</script>
<style>
.avatar-uploader .avatar {
    height: 260px;
    width: 185px;
    display: block;
    object-fit: cover;
}
.avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    height: 260px;
    width: 185px;
    text-align: center;
}

.event-base-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}
.event-part1-l{
    width: calc(100% - 270px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.event-info-item-auto{
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.event-part1-r{
    width: 270px;
    height: 100%;
}
.event-base-info-cover{
    width: 270px;
    height: 152px;
    box-sizing: border-box;
    img{
        width: 100%;
        height: 100%;
    }
}
.event-book-container{
    width: 85%;
    height: auto;
    display: flex;
    flex-wrap: wrap!important;
    margin-left: 30px;
    margin-top: 5px;
    margin-bottom: 10px;
}
.book-list-one{
    width: 140px;
    height: 210px;
    margin-right: 10px;
    border: 1px solid #dcdfe6;
}
.book-cover{
    width: 140px;
    height: 180px;
}
.book-t{
    color: #333333;
    font-size: 15px;
    font-family: sans-serif;
    height: 30px;
    line-height: 30px;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 显示省略号 */
}
.item-span{
    font-weight: bold;
    color: #377f7f;
}
@media (max-width: 1024px) {
    .event-base-info-container { flex-direction: column; }
    .event-part1-l { width: 100%; padding-right: 0; }
    .event-part1-r { width: 100%; margin-top: 20px; }
    .event-base-info-cover { width: 240px; height: 135px; }
    .event-book-container { width: 100%; margin-left: 0; }
}
</style>
